import React from 'react';
import { useTranslatedContent } from '../../i18n/hooks/useTranslatedContent';
import ZimbraSolution from './solutions/ZimbraSolution';
import LemonLDAPSolution from './solutions/LemonLDAPSolution';
import NextcloudSolution from './solutions/NextcloudSolution';
import OpenLDAPSolution from './solutions/OpenLDAPSolution';
import ITSMSolution from './solutions/ITSMSolution';
import FusionDirectorySolution from './solutions/FusionDirectorySolution';
import MeetingSolution from './solutions/MeetingSolution';
import ERPSolution from './solutions/ERPSolution';
import CRMSolution from './solutions/CRMSolution';

const SolutionsSection = () => {
  const { t } = useTranslatedContent('products');

  return (
    <div id="solutions" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900">{t('title')}</h2>
          <p className="mt-4 text-xl text-gray-600">{t('subtitle')}</p>
        </div>

        <div className="mt-16 space-y-20">
          {/* Core Solutions */}
          <ZimbraSolution />
          <LemonLDAPSolution />
          <NextcloudSolution />
          <OpenLDAPSolution />
          
          {/* Business Solutions */}
          <div id="erp">
            <ERPSolution />
          </div>
          <div id="crm">
            <CRMSolution />
          </div>
          
          {/* Infrastructure Solutions */}
          <ITSMSolution />
          <FusionDirectorySolution />
          <div id="meeting">
            <MeetingSolution />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SolutionsSection;